import { DataBean } from "../DataBean";

export class QuotaTimeTerm extends DataBean {

    public async getQuotaTimeTermCatalog(idQuotaTimeTerm: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getQuotaTimeTermCatalog_Number", [idQuotaTimeTerm]);
    }

    public async getLoanTimeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLoanTimeConstants_Number", [arg]);
    }

    public async deleteQuotaTimeTerm(idQuotaTimeTerm: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteQuotaTimeTerm_Number", [idQuotaTimeTerm]);
    }

    public async updateQuotaTimeTerm(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.loans.QuotaTimeTerm_updateQuotaTimeTerm_com.quickdataerp.bean.loans.QuotaTimeTerm", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.loans.QuotaTimeTerm"
            }
        ]);
    }

}
